import { render, staticRenderFns } from "./lay-menu.vue?vue&type=template&id=f0c9d386&scoped=true"
import script from "./lay-menu.vue?vue&type=script&lang=js"
export * from "./lay-menu.vue?vue&type=script&lang=js"
import style0 from "./lay-menu.vue?vue&type=style&index=0&id=f0c9d386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c9d386",
  null
  
)

export default component.exports